import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-terms-cookies',
  templateUrl: './terms-cookies.component.html',
  styleUrls: ['./terms-cookies.component.scss']
})
export class TermsCookiesComponent implements OnInit {


  url: any;
  cont: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public seo: SeoService,
    public api: RestapiService
  ) { }

  ngOnInit(): void {
    this.loadContent()
  }

  loadContent() {
    this.api.getdata('websection', {
      filters: { webroute_id : { value: 12 } }
    }).subscribe(res => {
      if (res.status == true) {
        console.log('CURRENT WEBSECTION', res);
        this.cont = res.result.data[0];
        this.seo.generateTags({
          title:'WWF Educación Ambiental, Politica de uso de datos',
          description: 'Politica de uso de datos',
          image: '/assets/brand.png',
          slug: window.location.href,
        });
      }
      else {
        console.log('ERROR ON LOAD', this.url);
      }
    })
  }

}
